import {Observable} from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ReportModel } from '../../../data-transfer-objects/custom/senheng/report-dto.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { BasicApiResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';

@Injectable({ providedIn: 'root' })
export class ReportsService extends BaseApiTemplateService<ReportModel> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX  + Core2Config.SENHENG_PREFIX +Core2Config.ERP_PREFIX + 'reports';
    this.endpoint_path = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENHENG_PREFIX +Core2Config.ERP_PREFIX + 'reports';
    this.httpClient = theHttp;
    }


    postReport(dtoObject: ReportModel, visa: ApiVisa): Observable<BasicApiResponseModel<ReportModel>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.post<BasicApiResponseModel<ReportModel>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }
    

}